import { CollapsableSection, Column, Columns, FormInput, ReadOnly, TopSection } from "lqx-react";
import * as React from "react";
import { localUserInfo, OptionalOrgInfo, OrgInfo, ShippingInfo } from 'api';

export interface ShippingProps {
  shipping: ShippingInfo;
  ship_to: OrgInfo;
  bill_to: OptionalOrgInfo;
  end_customer: OptionalOrgInfo;
}

export const Shipping = ({ shipping , ship_to, bill_to, end_customer } : ShippingProps) => {
  const readOnly = React.useContext( ReadOnly ) || !localUserInfo.canFull;
  const showCollapsed=!shipping || (!shipping.method && !shipping.carrier && !shipping.account && !shipping.instructions);
  return (shipping ?
    <ReadOnly.Provider value={ readOnly }>
      <TopSection id="shipping-details" title="Shipping Details">
        <CollapsableSection title="" notExpanded={showCollapsed}>
          <Columns>
            <Column>
              <FormInput readOnly label="Account" value={shipping.account} />
              <FormInput readOnly label="Carrier" value={shipping.carrier} />
              {/*<FormInput readOnly label="Distributor PO#" value={shipping.po_number} />*/}
            </Column>
            <Column>
              <FormInput readOnly label="Instructions" value={shipping.instructions} />
              <FormInput readOnly label="Method" value={shipping.method} />
            </Column>
          </Columns>
        </CollapsableSection>

        {/*{ship_to ? <CollapsableAddress id="ship-to" title="Ship To" model={ship_to} /> : null}*/}
        {/*{bill_to ? <CollapsableAddress id="bill-to" title="Bill To" model={bill_to} /> : null}*/}
        {/*{end_customer ? <CollapsableAddress id="end-customer" title="End Customer" model={end_customer} /> : null}*/}
      </TopSection>
    </ReadOnly.Provider> : null
  )
}
